import React, { useState, useEffect } from "react";
import { setReminderOndemand } from "../../../services/medium";
import { toast } from "react-toastify";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import "./index.css";
import { use } from "react";
import { saveSessionTerms } from "../../../services/client";
import { setSaveTermsHanlder, setSaveTermsHanlderPD } from "../../../reducer/userSlice";
import ScrollDown from "../../../components/scrolldownicon";
import ScrollDownPopup from "../../../components/scrolldowniconforpopup";
import { useTranslation } from "react-i18next";

export default function QuestionPopUp({
  directAppMediumInfo,
  booKGroupEvent,
  isBookingInProgress,
}) {
  const { t } = useTranslation("clientOnDemand");
  const [value, setValue] = useState("");

  const { timezone_name } = useSelector((state) => state.user.user);
  const [isWorker, setIsWorker] = useState(false);

  const auth = useSelector((state) => state.user);
  const [error, setError] = useState(false);
  const [checkall, setCheckAll] = useState(false);
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);

  const [check7, setCheck7] = useState(false);

  const [check8, setCheck8] = useState(false);
  const [check9, setCheck9] = useState(false);
  const [check10, setCheck10] = useState(false);
  const [check11, setCheck11] = useState(false);
  const [check12, setCheck12] = useState(false);
  const [check13, setCheck13] = useState(false);
  const [check14, setCheck14] = useState(false);
  const [showBtn, setShowBtn] = useState(false);
  const [check16, setCheck16] = useState(false);
  // const [checkYes, setCheckYes] = useState(false);
  // const [checkNo, setCheckNo] = useState(false);
  const dispatch = useDispatch();

  const changeHandler = (e, setCheck, type) => {

    setCheck(e.target.checked);

  };

  //   const changeHandlerAll = (e) => {
  //     setCheckAll(e.target.checked);
  //     setCheck1(e.target.checked);
  //     setCheck2(e.target.checked);
  //     setCheck3(e.target.checked);
  //     setCheck7(e.target.checked);
  //     setCheck8(e.target.checked);
  //     setCheck9(e.target.checked);
  //     setCheck10(e.target.checked);
  //     setCheck11(e.target.checked);
  //     setCheck12(e.target.checked);
  //     setCheck13(e.target.checked);
  //     setCheck14(e.target.checked);
  //     setCheck16(e.target.checked);
  //   };

  const validator = () => {
    return (
      check1 &&
      check2 &&
      check7 &&
      check8 &&
      check9 &&
      check10 &&
      check11 &&

      check14 &&
      check3
    );
  };
  const onClickHandler = () => {
    if (validator()) {
      setError(false);
      if (auth.user.terms_session_pd_status == 0) {
        callAPI();
      }
      booKGroupEvent();

    } else {
      setError(true);
    }
  };
  const changeHandlerAll = (e) => {
    const checked = e.target.checked;

    setCheckAll(checked);
    setCheck1(checked);
    setCheck2(checked);
    setCheck3(checked);
    setCheck7(checked);
    setCheck8(checked);
    setCheck9(checked);
    setCheck10(checked);
    setCheck11(checked);
    setCheck12(checked);
    setCheck13(checked);
    setCheck14(checked);
    setCheck16(checked);
  };

  useEffect(() => {
    console.log(directAppMediumInfo, "directAppMediumInfo");
    resetChecks();
  }, [directAppMediumInfo]);

  const currentUserDate = (day) => moment(day, 'YYYY-MM-DD').format("dddd MMMM DD, YYYY");
  const { medium_name = "", fullday = "", backupdate = '', title = "", ondemand_session_category_id, subtext = "" } = directAppMediumInfo
  const resetChecks = () => {
    setCheckAll(false);
    setCheck1(false);
    setCheck2(false);
    setCheck3(false);
    setCheck7(false);
    setCheck8(false);
    setCheck9(false);
    setCheck10(false);
    setCheck11(false);
    setCheck12(false);
    setCheck13(false);
    setCheck14(false);
    setCheck16(false);
    setError(false);
  };
  useEffect(() => {
    const modal = document.getElementById("QuestionPopUp");

    if (modal) {
      modal.addEventListener("show.bs.modal", resetChecks);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("show.bs.modal", resetChecks);
      }
    };
  }, []);
  const callAPI = () => {

    // const getSessionTerms = (data) => {

    let body = {
      terms_and_condition_pd: JSON.stringify(1),
    };
    saveSessionTerms(body)
      .then((data) => {

        if (data.data.status) {
          console.log("success");
          dispatch(setSaveTermsHanlderPD());
        }
      })
      .catch(() => {

      });

  }
 const handleClose = () => {
   window.loadModal2("#QuestionPopUp", "hide");
};
  return (
    <div>
      <div
        id="QuestionPopUp"
        class="modal fade bd-example-modal-lg mt-5 preview-modal-availability"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      // data-backdrop="static"
      >
        <div class="modal-dialog modal-xl modal-dialog-preview text-center">
          <div class="modal-content">

            {/* Close Icon */}
            <button
              type="button"
              className="close-btn-tc"
              onClick={handleClose}
            >
              ✕
            </button>
            <div className="modal-header-custom">
              <h2 className="modal-title-main">
                {t("review.title")}
              </h2>
            </div>
            <div class="container-fluid question-container question-container-new">
              <div class="row justify-content-center">
                <div class="">
                  <div class="">
                    <form id="msform" className="question-form">
                      <fieldset>
                        <div class="form-card">
                          <div class="row wrap">
                            <h2 className="text-center">
                              {t("review.instructions")}
                            </h2>
                            {auth.user.terms_session_pd_status == 1 ? (
                              <div class="new margin-unset">
                                <div class="form-group">
                                  <input
                                    type="checkbox"
                                    id="checkall"
                                    checked={checkall}
                                    onChange={changeHandlerAll}
                                  />
                                  <label htmlFor="checkall">
                                    <strong>{t("review.agreeAll")}</strong>
                                  </label>
                                </div>
                              </div>
                            ) : ""}
                            <h2>{t("review.iAm")}</h2>
                            <div class="new margin-unset">
                              <div class="form-group">
                                <input
                                  onChange={(e) => {
                                    changeHandler(e, setCheck1);
                                  }}
                                  checked={check1}
                                  name="check1"
                                  type="checkbox"
                                  id="check1"
                                />
                                <label htmlFor="check1">{t("review.open")}</label>
                              </div>
                              <div class="form-group">
                                <input
                                  onChange={(e) => {
                                    changeHandler(e, setCheck2);
                                  }}
                                  checked={check2}
                                  name="check2"
                                  type="checkbox"
                                  id="check2"
                                />
                                <label htmlFor="check2">
                                  {t("review.interpreter")}

                                </label>
                              </div>
                              <div class="form-group">
                                <input
                                  onChange={(e) => {
                                    changeHandler(e, setCheck3);
                                  }}
                                  checked={check3}
                                  name="check3"
                                  type="checkbox"
                                  id="check3"
                                />
                                <label htmlFor="check3">
                                  {t("review.zoomDevice")}

                                </label>
                              </div>
                              <h2>{t("review.iUnderstand")}</h2>
                              <div class="form-group">
                                <input
                                  onChange={(e) => {
                                    changeHandler(e, setCheck7);
                                  }}
                                  checked={check7}
                                  name="check7"
                                  type="checkbox"
                                  id="check7"
                                />
                                <label htmlFor="check7">
                                  {t("review.fee")}

                                </label>
                              </div>
                              <div class="form-group">
                                <input
                                  checked={check8}
                                  onChange={(e) => {
                                    changeHandler(e, setCheck8);
                                  }}
                                  name="check8"
                                  type="checkbox"
                                  id="check8"
                                />
                                <label htmlFor="check8">
                                  {t("review.noCommunication")}

                                </label>
                              </div>

                              <div class="form-group">
                                <input
                                  onChange={(e) => {
                                    changeHandler(e, setCheck14);
                                  }}
                                  checked={check14}
                                  name="check14"
                                  type="checkbox"
                                  id="check14"
                                />
                                <label htmlFor="check14">
                                  {t("review.notRecorded")}

                                </label>
                              </div>
                              {/*****In understabd */}
                              <h2>{t("review.iAgree")}</h2>
                              <div class="form-group">
                                <input
                                  onChange={(e) => {
                                    changeHandler(e, setCheck9);
                                  }}
                                  checked={check9}
                                  name="check9"
                                  type="checkbox"
                                  id="check9"
                                />
                                <label htmlFor="check9">
                                  {t("review.early")}

                                </label>
                              </div>
                              <div class="form-group">
                                <input
                                  checked={check10}
                                  onChange={(e) => {
                                    changeHandler(e, setCheck10);
                                  }}
                                  name="check10"
                                  type="checkbox"
                                  id="check10"
                                />
                                <label htmlFor="check10">
                                  {t("review.doorsClosed")}

                                </label>
                              </div>

                              <div class="form-group">
                                <input
                                  onChange={(e) => {
                                    changeHandler(e, setCheck11);
                                  }}
                                  checked={check11}
                                  name="check11"
                                  type="checkbox"
                                  id="check11"
                                />
                                <label htmlFor="check11">
                                  {" "}
                                  {t("review.responsibility")}
                                </label>
                              </div>
                              {/*****I agree that */}


                              {error && (
                                <div>
                                  <p className="red">{t("review.selectAll")}</p>
                                </div>
                              )}
                              <div></div>
                            </div>
                          </div>
                        </div>
                        {/* {!showBtn && ( */}
                        {/* <input
                  onClick={onCancelQuestions}
                  type="button"
                  name="previous"
                  class="previous action-button-previous"
                  value="Cancel"
                /> */}
                        {/* )} */}

                        {/* {!showBtn ? ( */}
                        <>
                          {/* {url !== undefined && url ? (
                    <a
                      href={
                        !validator()
                          ? "javascript:void(0);"
                          : "https://appointments.verysoul.com/reserve/donated-free"
                      }
                      className={`next action-button`}
                      onClick={onClickSaveTerms}
                    >
                      Next
                    </a>
                  ) : ( */}
                          <input
                            onClick={() => onClickHandler()}
                            type="button"
                            name="next"
                            class="next action-button action-button-previous-new"
                            disabled={isBookingInProgress}
                            value={t("review.continue")}
                          />
                          {/* )

                  } */}
                        </>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {/* <ScrollDownPopup containerClass=".question-container" bottomOffset="30px" /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
